export default {
    title: `Estamos fundando uan academia que juega el papel de líder!`,
    rightTitle: `Somos la educación nuevamente definida que va a crear nuevas historias.`,
    timelineData: [
        {
            year: 2013,
            title: 'Airclass fue fundada',
            content: `Airlcass fue fundada para la educación dedicada a cursos individuales
            virtuales (uno a uno) para estudiantes de 5-18 años, y su alcance de negocios cubre todas las asignaturas y todas las escalas de educación.`
        },
        {
            year: 2017,
            title: 'Airclass tiene más de 300.000 de usuarios',
            content: 'Airclass está agendando más de 150.000 sesiones de tutoría cada mes, y sus ingresos anuales ha sobrepasado a mil milliones.'
        },
        {
            year: 2018,
            title: 'Airclass ya recibió 120 milliones dólares',
            content: `El lanzamiento del proyecto social "Lighthouse (Faro)"y "Convoy Plan (Plan de Convoy)"ha protegido a los estudiantes les ha ayudado a
            hacer realidad sue sueños.
            `
        },
        {
            year: 2020,
            title: 'Airclass invierte más de 400 milliones dólares en la fianza.',
            content: 'Airclass invierte más de 400 milliones dólares en la fianza.',
        },
        {
            year: 2021,
            title: 'Airclass tiene más de 500.000 estudiantes con pagos realizados.',
            content: `Hasta hoy, Airclass ya tiene más de 514.419 estudiantes, y estamos esperando a que la magnitud del equipo crezca a más de 30.000 empleados y 10.000 tutores.`
        },
    ],
    historyData: [
        {
            icon: 'https://web-data.zmlearn.com/image/9LJKzxBKqAvqE74un34Vum/%E7%BC%96%E7%BB%84%203%402x.png',
            count: '113',
            txt: 'PAÍSES'
        },
        {
            icon: 'https://web-data.zmlearn.com/image/6NUCmNNoH2juzDj8RDT8rP/%E7%BC%96%E7%BB%84%204%402x.png',
            count: '10,000+',
            txt: 'TUTRES'
        },
        {
            icon: 'https://web-data.zmlearn.com/image/ethUAXVfzB84An16gJooNE/%E7%BC%96%E7%BB%84%205%402x.png',
            count: '50,000,000+',
            txt: 'USUARIOS'
        },
        {
            icon: 'https://web-data.zmlearn.com/image/5XBcX14p8psdQQrsnn7iou/%E7%BC%96%E7%BB%84%206%402x.png',
            count: '500,000+',
            txt: 'ESTUDIANTES'
        },
        {
            icon: 'https://web-data.zmlearn.com/image/qQtsKq9kqKpP27WD74qZz/%E7%BC%96%E7%BB%84%207%402x.png',
            count: '30,000+',
            txt: 'EMPLEADOS'
        },
    ]
}
